import React, { useEffect, useState } from "react";
import Inputbox from "../../../Components/Inputbox";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
  AgencySidePaitentEMERcontact,
  AgencySidePaitentEMERcontactUpdate,
  Deletecontact,
  Fetchemergencycontact,
  UpdateAgencySidePaitentEMERcontact,
} from "../../../../api/helper";
import { ShowToast } from "../../../../helpers/ToastService";
import { useSelector } from "react-redux";
import DeleteModal from "../../Components/DeleteModal";

const validationSchema = Yup.object().shape({
  contactName: Yup.string().required("Contact Name is required"),

  phoneNumber: Yup.string()
    .matches(/^[0-9]{10}$/, "Phone number must be 10 digits")
    .required("Phone number is required"),

  relation: Yup.string().required("relation is required"),

  email: Yup.string()
    .email("Invalid email address")
    .required("email is required"),
});

const EmergencyContacts = ({ info, getDteails }) => {
  const [ismodal, setismodal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null);
  const profileData = useSelector((state) => state?.cookies?.userDetails);
  const [contactdata, setcontactdata] = useState();
    const [confirmdeletemodal, setconfirmdeletemodal] = useState(false);
    const [deleteId, setdeleteId] = useState(null);
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = async (data) => {
    const baseData = {
      contactName: data.contactName,
      phoneNumber: data.phoneNumber,
      relation: data.relation,
      email: data.email,
      patientId: info?.patientId?._id,
      agencyId: profileData?._id,
    };

    try {
      if (isEditMode && selectedContact) {
        const payload = {
          contactId: selectedContact._id,
          updateData: {
            contactName: baseData.contactName,
            phoneNumber: baseData.phoneNumber,
            relation: baseData.relation,
            email: baseData.email,
          },
        };
        const response = await UpdateAgencySidePaitentEMERcontact(payload);
        ShowToast(response?.data?.message || "Contact updated successfully");
      } else {
        const response = await AgencySidePaitentEMERcontact(baseData);
        ShowToast(response?.data?.message || "Contact added successfully");
      }

      reset();
      setismodal(false);
      setIsEditMode(false);
      setSelectedContact(null);
      getEmergencycontact();
    } catch (error) {
      console.log(error);
    }
  };

  const getEmergencycontact = async () => {
    try {
      const Respo = await Fetchemergencycontact(
        profileData?._id,
        info?.patientId?._id
      );
      setcontactdata(Respo?.data?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getEmergencycontact();
  }, []);

  const handleRemove = (id) => {
    setdeleteId(id);
    setconfirmdeletemodal(true);
  };

  const confirmDelete = async () => {
    setconfirmdeletemodal(false);
    const data = {
      contactId: deleteId,
      agencyId: profileData?._id,
      patientId: info?.patientId?._id,
    };
    try {
      const respo = await Deletecontact(data);
      ShowToast(respo?.data?.message);
      getEmergencycontact();
    } catch (error) {
      console.log(error);
    }
  };

  const UpdateisPrimary = async (contactId, currentIsPrimary) => {
    const isPrimary = !currentIsPrimary;
    const data = {
      contactId,
      agencyId: profileData?._id,
      patientId: info?.patientId?._id,
      isPrimary,
    };
    try {
      const respo = await AgencySidePaitentEMERcontactUpdate(data);
      getEmergencycontact();
      getDteails();
    } catch (error) {
      console.log(error);
    }
  };

  const handleEdit = (contact) => {
    setismodal(true);
    setIsEditMode(true);
    setSelectedContact(contact);
    setValue("contactName", contact.contactName);
    setValue("phoneNumber", contact.phoneNumber);
    setValue("relation", contact.relation);
    setValue("email", contact.email);
  };

  return (
    <>
      <div className="container_NotesTabScreen">
        <h1>Emergency Contacts</h1>

        <button
          className="add-button_NotesTabScreen"
          style={{ float: "right" }}
          onClick={() => {
            setismodal(true);
          }}
        >
          Add Contact
        </button>
        <div
          className="tabs-container__three"
          style={{ display: "flex", width: "100%", justifyContent: "left" }}
        />

        <table id="member-table">
          <thead>
            <tr>
              <th>Contact Name</th>
              <th>Phone Number</th>
              <th>Relation</th>
              <th>Email</th>
              <th>Action</th>
              <th>Primary</th>
            </tr>
          </thead>
          {contactdata && contactdata.length > 0 ? (
            contactdata?.map((contact) => (
              <tr key={contact._id}>
                <td>{contact.contactName}</td>
                <td>{contact.phoneNumber}</td>
                <td>{contact.relation}</td>
                <td>{contact.email}</td>

                <td className="custom-action-td">
                  <div className="custom-dropdown">
                    <button className="custom-action-button">⋮ Actions</button>
                    <div className="custom-dropdown-menu">
                      <ul>
                        <li>
                          <button className="custom-dropdown-item"
                            onClick={() => handleEdit(contact)}
                          >Edit</button>
                        </li>

                        <li>
                          <button
                            className="custom-dropdown-item"
                            onClick={() => handleRemove(contact._id)}
                          >
                            Delete
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
                <td>
                  <input
                    type="checkbox"
                    checked={contact?.isPrimary}
                    onChange={() =>
                      UpdateisPrimary(contact._id, contact.isPrimary)
                    }
                  />
                </td>
              </tr>
            ))
          ) : (
            <p style={{ textAlign: "left", marginTop: 10 }}>No Contact Found</p>
          )}
        </table>
        {ismodal && (
          <div className="modal_twooo" id="add-member-modal">
            <h2>Add Emergency Contact</h2>
            <div id="facility" className="tab-content">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group">
                  <label htmlFor="facility-search-facility">Contact Name</label>
                  <input
                    type="search"
                    id="facility-search-facility"
                    placeholder="Enter Contact Name"
                    {...register("contactName")}
                  />
                  {errors.contactName && (
                    <p className="error-message">
                      {errors.contactName.message}
                    </p>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="from-date-facility">Phone Number</label>
                  <input
                    type="number"
                    id="from-date-facility"
                    placeholder="Enter Phone Number"
                    {...register("phoneNumber")}
                  />
                  {errors.phoneNumber && (
                    <p className="error-message">
                      {errors.phoneNumber.message}
                    </p>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="relation">Relation</label>
                  <select id="relation" {...register("relation")}>
                    <option value="">Select Relation</option>
                    <option value="Parent">Parent</option>
                    <option value="Sibling">Sibling</option>
                    <option value="Spouse">Spouse</option>
                    <option value="Child">Child</option>
                    <option value="Friend">Friend</option>
                    <option value="Other">Other</option>
                  </select>
                  {errors.relation && (
                    <p className="error-message">{errors.relation.message}</p>
                  )}
                </div>

                <div className="form-group">
                  <label htmlFor="to-date-facility">Email</label>
                  <input
                    type="text"
                    id="to-date-facility"
                    placeholder="Enter Email"
                    {...register("email")}
                  />
                  {errors.email && (
                    <p className="error-message">{errors.email.message}</p>
                  )}
                </div>
                <div className="form-buttons">
                  <button
                    className="cancel"
                    type="button"
                    onClick={() => {
                      setismodal(false);
                    }}
                  >
                    Cancel
                  </button>
                  <button className="save" type="submit">
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
       {confirmdeletemodal && (
              <DeleteModal
                name="Emergency Contact"
                onClose={() => setconfirmdeletemodal(false)}
                onConfirm={confirmDelete}
              />
            )}
    </>
  );
};

export default EmergencyContacts;
